var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6387 5H2.36095C1.97742 5 1.6665 5.31091 1.6665 5.69444V16.8056C1.6665 17.1891 1.97742 17.5 2.36095 17.5H17.6387C18.0223 17.5 18.3332 17.1891 18.3332 16.8056V5.69444C18.3332 5.31091 18.0223 5 17.6387 5Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4723 5.00043V3.61155C13.4723 3.24319 13.3259 2.88992 13.0655 2.62945C12.805 2.36899 12.4517 2.22266 12.0834 2.22266H7.91672C7.54836 2.22266 7.1951 2.36899 6.93463 2.62945C6.67416 2.88992 6.52783 3.24319 6.52783 3.61155V5.00043",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 9.71484C15.8007 11.1801 12.9257 11.9495 9.99984 11.9449C7.0741 11.9495 4.19916 11.1805 1.6665 9.71571",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61133 9.16699H11.3891",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBriefcase;